import React, { useState } from 'react';
import './ShopSelectionStep.css';
import { Shop } from '../../models/types';
import { getShopFacadeImageUrl } from '../../utils/roomImages';

interface ShopSelectionStepProps {
    shops: Shop[];
    selectedShop: Shop | null;
    onShopSelect: (shop: Shop) => void;
}

const ShopImage: React.FC<{ shop: Shop }> = ({ shop }) => {
    const imageUrl = getShopFacadeImageUrl(shop.shop_id, shop.shop_name);
    const fallbackUrl = `https://via.placeholder.com/400x300/007bff/ffffff?text=${encodeURIComponent(shop.shop_name)}`;
    const [src, setSrc] = useState(imageUrl ?? fallbackUrl);

    return (
        <img
            src={src}
            alt={shop.shop_name}
            className="shop-image"
            onError={() => {
                if (src !== fallbackUrl) {
                    setSrc(fallbackUrl);
                }
            }}
        />
    );
};

const ShopSelectionStep: React.FC<ShopSelectionStepProps> = ({
    shops,
    selectedShop,
    onShopSelect,
}) => {
    const handleShopClick = (shop: Shop) => {
        onShopSelect(shop);
    };

    return (
        <div className="shop-selection-step">
            <div className="shops-grid">
                {shops.map((shop) => (
                    <div
                        key={shop.shop_id}
                        className={`shop-card ${selectedShop?.shop_id === shop.shop_id ? 'selected' : ''}`}
                        onClick={() => handleShopClick(shop)}
                    >
                        <div className="shop-name-top">{shop.shop_name}</div>
                        <div className="shop-image-container">
                            <ShopImage shop={shop} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ShopSelectionStep;
